// Pivot d'une liste pour le transformer en tableau


/// Paramètres
// -> datas : données complètes 
// -> colToPivot : nom de la colonne sur laquelle effectuer le pivot
// -> colsToKeep : array des nom des colonnes à conserver
// -> colId : nom de la colonne contenant l'ID de la ligne (cette colonne doit être dans colsToKeep)
// -> dataField : colonne des valeurs associées à colToPivot
function Pivot(datas, colToPivot, colsToKeep, colId, dataField) {

  // Liste des colonnes à afficher + les données "fixes" 
  var columns = [];
  var fixedColumns = [];

  datas.forEach(d => {

    // On prend les colonnes dynamiques
    if (!columns.includes(d[colToPivot])) {
      columns.push(d[colToPivot]);
    }

    // Données fixes
    var fixedColum = {};
    colsToKeep.forEach(f => {
      fixedColum[f] = d[f];
    });
    fixedColumns.push(fixedColum);
  });

  // On dédoublonne la liste d'objets
  fixedColumns = [...new Map(fixedColumns.map(item => [item[colId], item])).values()];

  // Tableau de retour
  var returnArray = [];

  // On parcourt la liste des éléments qui seront à afficher
  fixedColumns.forEach(fixedElement => {

    // Objet de retour qu'on ajoutera dans la liste
    var returnObject = {};

    // On parcourt les attributs des objects de la liste de manière dynamique
    Object.keys(fixedElement).forEach(c => {
      returnObject[c] = fixedElement[c];
    });

    // Colonnes dynamiques
    columns.forEach(c => {
      var el = datas.filter(d => d[colId] == fixedElement[colId]).find(d => d[colToPivot] == c);
      returnObject[c] = el == undefined ? null : el[dataField];
    })

    returnArray.push(returnObject);
  });

  return returnArray;

}

export default { Pivot }
export { Pivot }



// WEBPACK FOOTER //
// ./src/utils/pivot.js